import {useState} from "react";
import Spinner from "../../../../../../../../core/components/spinner";
import Typo from "../../../../../../../../core/components/typo";
import {useAuthContext} from "../../../../../../../Auth/provider/AuthProvider";
import RenderIf from "../../../../../../../../core/components/render-if";
import Button from "../../../../../../../../core/components/button";
import __ from "../../../../../../../../core/utils/translate/translate";
import {useNavigate} from "react-router-dom";
import {useLeftTeam} from "../../../../../../../Auth/api/auth";
import handleError from "../../../../../../../../core/helper/handelError";

const ProfilePersonCheckTeam = () => {
    const [canDeleteRequest, setCanDeleteRequest] = useState(true);
    const {team} = useAuthContext();
    const navigate = useNavigate();
    const {mutate: leftMyTeam,} = useLeftTeam();

    const handleLeft = () => {

        leftMyTeam({team_user_id: team.id},
            {
                onSuccess: () => {

                    navigate("/app/profile");
                    navigate(0);


                },
                onError: (e) => {
                    handleError(e)
                }
            });
    };
    const handleRefetch = () => {
        navigate(0)
    };

    let headOfTeam = null;
    if(team?.team?.heads?.length > 0)
    {
        if(!!team?.team?.heads[0]?.user?.firstName || !!team?.team?.heads[0]?.user?.lastName)
        {
            headOfTeam = (team?.team?.heads[0]?.user?.firstName ?? '') + ' ' +
                (team?.team?.heads[0]?.user?.lastName ?? '' )
        }

    }

    return (
        <div
            className="absolute inset-0 z-[2] flex flex-col items-center justify-center gap-4 rounded-3xl bg-white bg-opacity-50 p-2 backdrop-blur-sm">
            <div className="flex flex-col text-center items-center justify-center gap-4">
                <div className="text-xl font-bold">

                    <b>⏳ منتظر تایید سرتیم هستی!</b>
                </div>

                <p>بعد از اینکه درخواستت رو تایید کنه، این بخش برات فعال میشه.</p>
                <p className={'font-bold'}>
                    <RenderIf cond={!!headOfTeam} >
                        در حال حاضر درخواستت برای تیم
                        {' '}
                        <span onClick={handleRefetch} className={`px-1 text-blue-800`}> {team?.team?.name ?? "..."} </span>
                        {' '}
                        <RenderIf cond={headOfTeam}>
                            هنوز تایید نشده و باید منتظر باشی تا سرتیم
                            {' '}
                            <span className={'text-blue-800'}>{headOfTeam}</span>
                            {' '}
                            اون رو تایید کنه
                        </RenderIf>

                    </RenderIf>
                    <RenderIf cond={!headOfTeam} >
                        در حال حاضر درخواستت برای تیم
                        {' '}
                        <span onClick={handleRefetch} className={`px-1 text-blue-800`}> {team?.team?.name ?? "..."} </span>
                        {' '}
                        هنوز تایید نشده
                    </RenderIf>

                </p>


                {/*<RenderIf cond={true} falsyElement={<Spinner type="accent"/>}>*/}
                {/*    <Typo onClick={handleRefetch} className="hover:underline" size="xs">*/}
                {/*        برای چک کردن وضعیت درخواستت اینجا کلیک کن!*/}

                {/*    </Typo>*/}
                {/*</RenderIf>*/}

                <RenderIf cond={canDeleteRequest}>
                    <div className="flex items-center gap-2">
                        {/*<Typo type="warning" className="bg-yellow/20" size="xs">*/}
                        {/*    {__("Your request has not been approved yet!")}*/}
                        {/*</Typo>*/}
                        <Button
                            size="xs"
                            scale="fit"
                            isLoading={false}
                            onClick={() => {
                                handleLeft()
                            }}
                        >
                            {__("Cancel the request")}
                        </Button>
                    </div>
                </RenderIf>
            </div>

        </div>
    );
};

export default ProfilePersonCheckTeam;
